import { useWidgetData } from '../useWidgetData'

import { StatisticValueMetadata } from '../../../types/court/court'
import { ReportPeriod } from '../../../types/report/report'
import {
  createReportInterval,
  createReportQuery,
} from '../../../utils/reportUtils'

export const useActiveMembersWidget = () => {
  const currentMonth = createReportInterval({
    period: ReportPeriod.THIS_MONTH,
    startDate: null,
    endDate: null,
  })

  return useWidgetData<StatisticValueMetadata>(
    `active-members?${createReportQuery(currentMonth)}`
  )
}
